var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-toggle',{ref:"toggle",class:['cctoggle', _vm.fullwidth?'full-width':null, _vm.noborder?'no-border':null, _vm.thinlabel?'thinlabel':null],attrs:{"value":_vm.value,"color":_vm.color,"label":_vm.label},on:{"input":_vm.updateInput}})}
var staticRenderFns = []

export { render, staticRenderFns }